import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { DollarSign, TrendingUp, Calendar } from 'lucide-react';

export const EarningsToggle = ({ earnings }) => {
  const [period, setPeriod] = useState('all'); // 'all', '7days', '30days'
  
  // Calculate period-based earnings (mock calculation for now)
  const getEarningsForPeriod = () => {
    if (!earnings) return { amount: 0, sales: 0 };
    
    switch (period) {
      case '7days':
        return {
          amount: earnings.last_7_days_earnings || (earnings.total_earnings * 0.15) || 0,
          sales: earnings.last_7_days_sales || Math.floor((earnings.total_sales || 0) * 0.15)
        };
      case '30days':
        return {
          amount: earnings.last_30_days_earnings || (earnings.total_earnings * 0.4) || 0,
          sales: earnings.last_30_days_sales || Math.floor((earnings.total_sales || 0) * 0.4)
        };
      default:
        return {
          amount: earnings.total_earnings || 0,
          sales: earnings.total_sales || 0
        };
    }
  };
  
  const periodData = getEarningsForPeriod();
  
  const periodLabels = {
    'all': 'Tüm Zamanlar',
    '7days': 'Son 7 Gün',
    '30days': 'Son 30 Gün'
  };
  
  return (
    <Card className="bg-gradient-to-br from-green-50 to-emerald-50 border-green-200">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-sm font-medium text-green-800 flex items-center gap-2">
            <DollarSign className="h-4 w-4" />
            Gelir Özeti
          </CardTitle>
          <div className="flex gap-1">
            {['7days', '30days', 'all'].map((p) => (
              <Button
                key={p}
                variant={period === p ? 'default' : 'ghost'}
                size="sm"
                className={`text-xs h-7 px-2 ${
                  period === p 
                    ? 'bg-green-600 hover:bg-green-700 text-white' 
                    : 'text-green-700 hover:bg-green-100'
                }`}
                onClick={() => setPeriod(p)}
              >
                {p === 'all' ? 'Tümü' : p === '7days' ? '7G' : '30G'}
              </Button>
            ))}
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="flex items-baseline gap-2">
          <span className="text-3xl font-bold text-green-700">
            ₺{periodData.amount.toFixed(2)}
          </span>
          <span className="text-sm text-green-600">
            {periodLabels[period]}
          </span>
        </div>
        <div className="flex items-center gap-4 mt-2 text-sm text-green-600">
          <span className="flex items-center gap-1">
            <TrendingUp className="h-3 w-3" />
            {periodData.sales} satış
          </span>
          <span className="flex items-center gap-1">
            <Calendar className="h-3 w-3" />
            %20 platform payı
          </span>
        </div>
      </CardContent>
    </Card>
  );
};

export default EarningsToggle;
